import axios from 'axios'
import moment from 'moment'
import config from '../variables/config'

export const REQUEST_SENT = 'dates/REQUEST_SENT'
export const MESSAGE_SHOWN = 'dates/MESSAGE_SHOWN'
export const REQUEST_FAILED = 'dates/REQUEST_FAILED'
export const REQUEST_FINISHED = 'dates/REQUEST_FINISHED'

const initialState = {
  data: [],
  requestFailed: false,
  requestLoading: false,
  requestFinished: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_SENT:
      return {
        ...state,
        requestLoading: true
      }

    case REQUEST_FAILED:
      return {
        ...state,
        requestFailed: true,
        requestLoading: false
      }

    case REQUEST_FINISHED:
      return {
        ...state,
        data: action.dates,
        requestFinished: true,
        requestLoading: false
      }

    case MESSAGE_SHOWN:
      return {
        ...state,
        requestFailed: false,
        requestFinished: false
      }

    default:
      return state
  }
}

export const fetchClasses = () => {
  return async (dispatch, getState) => {
    const token = getState().admin.token
    try {
      dispatch({ type: REQUEST_SENT })

      var classes = (await axios.get(
        config.serverURL + '/WKClass' + config.branch + '?access_token=' + token
      )).data
      if (Array.isArray(classes)) {
        dispatch({ type: REQUEST_FINISHED, data: classes })
      } else {
        dispatch({ type: REQUEST_FAILED })
      }
    } catch (error) {
      dispatch({ type: REQUEST_FAILED })
    }
  }
}

export const createClasses = data => {
  return async (dispatch, getState) => {
    const token = getState().admin.token
    try {
      var newClass = {
        name: data.name,
        ageDescription: data.ageDescription,
        phone: data.phone,
        datesOfClass: data.datesOfClass,
        startDate: data.startDate,
        endDate: data.endDate,
        classDescription: data.classDescription,
        prices: data.prices,
        ticketTitles: data.ticketTitles,
        teacherName: data.teacherName,
        studioName: data.string,
        link: data.string
      }
      await axios.post(
        config.serverURL +
          '/WKClass' +
          config.branch +
          '?access_token=' +
          token,
        newClass
      )

      dispatch(fetchClasses(true))
    } catch (error) {
      dispatch({ type: REQUEST_FAILED })
    }
  }
}

export const finishedRequest = () => {
  return dispatch => {
    dispatch({ type: MESSAGE_SHOWN })
  }
}
